import type { Faro, MeasurementEvent } from "@grafana/faro-web-sdk";

import type { UserInfo } from "../types";

let faro: Faro | undefined;

interface FaroConfig {
  url: string;
  samplingRate: number;
  build: string;
  environment: string;
}

export async function initFaro(config: FaroConfig, user: UserInfo) {
  const { getWebInstrumentations, initializeFaro } = await import("@grafana/faro-web-sdk");

  faro = initializeFaro({
    url: config.url,
    app: { name: "piplanning", version: config.build, environment: config.environment },
    sessionTracking: { samplingRate: config.samplingRate },
    instrumentations: [
      // Mandatory, overwriting the instrumentations array would cause the default instrumentations to be omitted
      ...getWebInstrumentations(),
      // This packages is optional because it increases the bundle size noticeably.
      // Only add it if you want tracing data.
      // new TracingInstrumentation(),
    ],
  });

  faro.api.setUser({ id: user.id, attributes: { company: user.company } });
}

export function pushFaroMeasurement(measurement: Omit<MeasurementEvent, "timestamp">) {
  faro?.api.pushMeasurement(measurement);
}

export function logoutFaroUser() {
  faro?.api.setUser({});
  faro = undefined;
}
